import {queryOptions} from '@tanstack/react-query';

import {fetchTeamInvites} from './fetchTeamInvites';
import {fetchTeamMembers} from './fetchTeamMembers';
import {fetchTeams} from './fetchTeams';

export const teamsQueryOptions = () =>
  queryOptions({
    queryKey: ['teams'],
    queryFn: fetchTeams,
  });

export const teamMembersQueryOptions = (id: string) =>
  queryOptions({
    queryKey: ['team-members', {id}],
    queryFn: () => fetchTeamMembers(id),
  });

export const teamInvitesQueryOptions = (id: string) =>
  queryOptions({
    queryKey: ['team-invites', {id}],
    queryFn: () => fetchTeamInvites(id),
  });
